// Meta (Facebook) Pixel ID — PUBLIC (it's loaded into the page), so it's safe to commit.
// kanarix-app is configured via wrangler.toml, so Cloudflare only allows *secrets* and
// Vite needs this at BUILD time — same situation as the Turnstile site key.
//
// ─── PASTE META PIXEL ID HERE ──────────────────────────────────────────────────
// Replace the '' on the LAST line below (this file: src/config/analytics.ts, the
// '' fallback) with your Pixel ID from Meta Events Manager → your pixel → Settings,
// e.g.  || '1234567890'. Leave '' to disable the browser Pixel.
export const META_PIXEL_ID =
  (import.meta.env.VITE_META_PIXEL_ID as string | undefined) || '838032122506706';
